module.exports = __webpack_public_path__ + "static/media/contact.445a6635.png";